
import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {
    OfferCard: () => import("@/components/Jobs/Common/OfferCard.vue"),
    Slick: () => import("vue-slick"),
    Postulate: () => import("@/components/postulation/Postulate.vue"),
    PostulationQuick: () =>
      import("@/components/postulation/PostulationQuick.vue")
  }
})
export default class RecentOffers extends Vue {
  offersRecentUser = [];
  msgTooltipDefault = {
    title: "Medimos tu Compatibilidad",
    description:
      "Si completas tu perfil con tus habilidades, podemos medir cuan compatible sos con esta oferta."
  };
  offerSlider = {
    slidesToShow: 2,
    slidesToScroll: 1,
    centerPadding: "16px",
    arrows: false,
    infinite: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.15,
          centerMode: true
        }
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1.15,
          centerMode: true
        }
      }
    ]
  };
  offersRecent = [];

  async mounted() {
    await (this as any).recent();
    await (this as any).postulations();
  }

  async recent() {
    const response = await (this as any).$root._get("offer/recent/2", {
      c_destino_publi: "JOBS"
    });
    for (let i = 0; i < response.data.length; i++) {
      response.data[i]["hover"] = false;
      response.data[i]["network"] = false;
    }
    (this as any).offersRecent = response.data;
  }

  async postulations() {
    if ((this as any).$store.state.token) {
      const response = await (this as any).$root._post(
        "useroffer/filtered_list",
        {
          postulate: 1,
          limit: 2,
          page: 1
        }
      );
      let offers: any = [];
      for (let i: number = 0; i < response.data.length; i++) {
        offers.push({
          ...response.data[i].offer,
          status: response.data[i].status,
          hover: false,
          network: false
        });
      }
      (this as any).offersRecentUser = offers;
    }
  }

  openModal(offer: any) {
    if ((this as any).$store.state.token) {
      let postulateComponent: any = (this as any).$children.find(
        (children: any) => {
          return children.$options._componentTag === "Postulate";
        }
      );
      postulateComponent.offerId = offer.id;
      postulateComponent.showModal();
    } else {
      let postulateComponent: any = (this as any).$children.find(
        (children: any) => {
          return children.$options._componentTag === "PostulationQuick";
        }
      );
      postulateComponent.offerId = offer.id;
      postulateComponent.showModal();
    }
  }

  show_detail(offer: any) {
    this.$store.commit("setOffer", offer);
    this.$router.push("ofertas/" + offer.id);
  }

  beforeUpdate() {
    // if (this.$refs.slick) {
    //   (this as any).$refs.slick.destroy();
    // }
  }

  updated() {
    // this.$nextTick(function() {
    //   if (this.$refs.slick) {
    //     (this as any).$refs.slick.create();
    //   }
    // });
  }
}
